// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"ed843a59","80":"da5f5477","98":"044bea4a","471":"5e115975","520":"4ca36e40","521":"427de2b9","648":"8e51beda","731":"64e99c8a","967":"8a3b4309"}[chunkId] + ".chunk.js";
};